import React, { createRef } from "react";
import axios from "axios";
import Navbar from "../components/Navbar";
import EventAccordion from "../components/EventAccordion";
import { getArtistCookie, pageFilter } from "../data/page_data";
import CssLoader from "../components/CssLoader";
import Loading from "../components/loading";
import Footer from "../components/Footer";
import { navigate, useLocation } from "@reach/router";
import * as ReactGA from "react-ga";
import { parse } from "query-string";
import FloatingButton from "../components/FloatingButton";
import WinnerSlider from "../components/WinnerSlider";

class EventPage extends React.Component {
  constructor(props) {
    super(props);
    this.skRef = createRef();
    let params = parse(this.props.location.search);
    this.code = params ? params.code : null;
    let mute = params ? params.muted : null;
    this.muted = mute === null ? this.props.muted : "true" === mute;
    this.pageData = pageFilter(this.props.artist, "../");
    this.state = {
      skOpen: false,
      isFullscreen: false,
    };
    this.videoRef = createRef();
  }

  handleFullscreen = () => {
    const videoElement = this.videoRef.current;
    if (videoElement.requestFullscreen) {
      videoElement.requestFullscreen();
    } else if (videoElement.mozRequestFullScreen) {
      videoElement.mozRequestFullScreen();
    } else if (videoElement.webkitRequestFullscreen) {
      videoElement.webkitRequestFullscreen();
    } else if (videoElement.msRequestFullscreen) {
      videoElement.msRequestFullscreen();
    }
  };

  handleFullscreenChange = () => {
    this.setState({
      isFullscreen:
        document.fullscreenElement === this.videoRef.current ||
        document.webkitFullscreenElement === this.videoRef.current ||
        document.mozFullScreenElement === this.videoRef.current ||
        document.msFullscreenElement === this.videoRef.current,
    });
  };

  componentDidMount() {
    document.addEventListener("fullscreenchange", this.handleFullscreenChange);
    document.addEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    document.addEventListener(
      "mozfullscreenchange",
      this.handleFullscreenChange
    );
    document.addEventListener(
      "MSFullscreenChange",
      this.handleFullscreenChange
    );

    let param = this.code ? "?code=" + this.code : "";
    axios
      .get("/w/api/" + this.pageData.artist.id + "/event" + param)
      .then((response) => {
        var respData = response.data;
        console.log("DATA", respData);
        this.setState((state) => ({ data: respData }));
      })
      .catch((error) => {
        console.log("ERROR", error);
      });
    ReactGA.pageview(window.location.pathname + window.location.search);
  }

  componentWillUnmount() {
    document.removeEventListener(
      "fullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "webkitfullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "mozfullscreenchange",
      this.handleFullscreenChange
    );
    document.removeEventListener(
      "MSFullscreenChange",
      this.handleFullscreenChange
    );
  }

  openSk = () => {
    this.setState({ skOpen: true });
    console.log("skRef", this.skRef);
    setTimeout(() => {
      window.scrollTo(0, this.skRef.current.offsetTop - 400);
    }, 200);
  };

  render() {
    const { isFullscreen } = this.state;
    return (
      <>
        <CssLoader css={this.pageData.artist.css} />
        {!this.props.noback && <Navbar data={this.pageData} title="EVENT" />}
        {!this.state.data ? (
          <>
            <Loading />
            <Footer />
          </>
        ) : (
          <>
            <div className="content event">
              <div className="event-img">
                {this.state.data.content ? (
                  <div
                  className={
                    "video-container " + (isFullscreen ? "" : "video-square")
                  }
                  >
                    <video
                      src={this.state.data.content.media_url}
                      autoPlay={this.props.autoplay}
                      playsInline={this.props.playsinline}
                      poster={this.state.data.content.image}
                      controls={this.props.control}
                      muted={this.props.muted}
                      loop={this.props.loop}
                      ref={this.videoRef}
                      onPlay={this.handleFullscreen}
                    ></video>
                  </div>
                ) : (
                  <img src={this.state.data.event.banner} />
                )}
              </div>
              <div className="container">
                {this.pageData.artist.floating_url && (
                  <FloatingButton url={this.pageData.artist.floating_url} />
                )}
                <div className="event-text">
                  {this.props.gabung && (
                    <button
                      type="button"
                      style={{
                        lineHeight: 1.5,
                        padding: "12px 24px",
                        fontWeight: "bold",
                        width: "unset",
                        margin: "0 auto",
                        textAlign: "center",
                      }}
                      onClick={() => {
                        document.location.href = this.pageData.artist.sms.tsel;
                      }}
                      className="btn btn-event-join"
                    >
                      GABUNG SEKARANG!
                    </button>
                  )}
                  <h5>{this.state.data.event.title}</h5>
                  {this.state.data.event.content
                    .split("\n")
                    .map((item, index) => {
                      return (
                        <p
                          style={{ fontSize: "1.1em" }}
                          dangerouslySetInnerHTML={{ __html: item }}
                        ></p>
                      );
                    })}
                </div>
                <hr />
                <div className="event-mekanisme">
                  <h5>Mekanisme Program Berhadiah:</h5>
                  <ul>
                    <li>
                      <span>
                        <h5>REGISTRASI</h5>
                        <p
                          dangerouslySetInnerHTML={{
                            __html: this.state.data.event.register,
                          }}
                        ></p>
                      </span>
                      <span>
                        <div className="em-img">
                          <svg
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 85.322 85.322"
                          >
                            <g>
                              <g className="a" transform="translate(0 0)">
                                <ellipse
                                  cx="42.661"
                                  cy="42.661"
                                  rx="42.661"
                                  ry="42.661"
                                />
                              </g>
                              <g
                                className="b"
                                transform="translate(0 0)"
                                clipPath="url(#clip-path)"
                              >
                                <g transform="translate(-37 18)">
                                  <path
                                    d="M90.531,60v5.625h-22.5V60H61v42.375H97.563V60ZM69.438,97.238,65.63,93.432l1.989-1.989,1.818,1.819,4.63-4.631,1.989,1.989Zm0-8.438L65.63,84.995l1.989-1.989,1.818,1.819,4.63-4.631,1.989,1.989Zm0-8.437L65.63,76.557l1.989-1.989,1.818,1.819,4.63-4.631,1.989,1.989Zm22.5,13.48H77.875V91.031H91.938Zm0-8.437H77.875V82.594H91.938Zm0-8.437H77.875V74.156H91.938Z"
                                    transform="translate(0 -54.375)"
                                  />
                                  <path
                                    d="M177.25,2.813a2.813,2.813,0,0,0-5.625,0H166V8.438h16.875V2.813Z"
                                    transform="translate(-95.156)"
                                  />
                                </g>
                              </g>
                            </g>
                          </svg>
                        </div>
                      </span>
                    </li>
                    {this.state.data.event.upload ? (
                      <li>
                        <span>
                          <h5>UPLOAD</h5>
                          <p>{this.state.data.event.upload}</p>
                        </span>
                        <span>
                          <div className="em-img">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 85.322 85.322"
                            >
                              <g className="a">
                                <ellipse
                                  cx="42.661"
                                  cy="42.661"
                                  rx="42.661"
                                  ry="42.661"
                                />
                              </g>
                              <g
                                className="b"
                                transform="translate(19.995 19.977)"
                              >
                                <g transform="translate(0 0)">
                                  <g transform="translate(-0.995 -0.977)">
                                    <g>
                                      <path d="M24,0A24,24,0,1,0,48,24,24,24,0,0,0,24,0Zm2.571,22.777V37.714H21.429V22.777H11.5L24,10.286,36.5,22.777Z" />
                                    </g>
                                  </g>
                                </g>
                              </g>
                            </svg>
                          </div>
                        </span>
                      </li>
                    ) : (
                      <></>
                    )}
                    {this.state.data.event.caption ? (
                      <li>
                        <span>
                          <h5>
                            {this.pageData.artist.id == 9
                              ? "KOMENTAR"
                              : "CAPTION"}
                          </h5>
                          <p
                            dangerouslySetInnerHTML={{
                              __html: this.state.data.event.caption,
                            }}
                          ></p>
                        </span>
                        <span>
                          <div className="em-img">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 85.04 85.04"
                            >
                              <g className="a">
                                <ellipse
                                  cx="42.52"
                                  cy="42.52"
                                  rx="42.52"
                                  ry="42.52"
                                />
                              </g>
                              <path
                                className="b"
                                d="M0,0V30.129H10.584V40l15.968-9.871H45.1V0ZM31.8,18.882H13.3V16.239H31.8v2.643Zm0-5.742H13.3V10.5H31.8V13.14Zm0,0"
                                transform="translate(20 28)"
                              />
                            </svg>
                          </div>
                        </span>
                      </li>
                    ) : (
                      <></>
                    )}

                    {this.state.data.event.follow ? (
                      <li>
                        <span>
                          <h5>FOLLOW</h5>
                          <p>{this.state.data.event.follow}</p>
                        </span>
                        <span>
                          <div className="em-img">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              viewBox="0 0 85.353 85.353"
                            >
                              <g className="a">
                                <ellipse
                                  cx="42.676"
                                  cy="42.676"
                                  rx="42.676"
                                  ry="42.676"
                                />
                              </g>
                              <g
                                className="b"
                                transform="translate(18.979 23.031)"
                              >
                                <path
                                  d="M131.61,188.379h-.58a6.3,6.3,0,0,0-6.288,6.012H137.9A6.3,6.3,0,0,0,131.61,188.379Z"
                                  transform="translate(-112.959 -170.614)"
                                />
                                <path d="M40.429,0H7.609C3.425,0,.021,3.681.021,8.206V28.93c0,4.525,3.4,8.206,7.588,8.206h9.854l5.3,10.107a1.415,1.415,0,0,0,2.505,0l5.3-10.107h9.854c4.184,0,7.588-3.681,7.588-8.206V8.206c0-4.525-3.4-8.206-7.588-8.206Zm-15.2,26.606H11.493a2.549,2.549,0,0,1-2.546-2.546,9.138,9.138,0,0,1,5.606-8.418,5.382,5.382,0,1,1,7.615,0,9.137,9.137,0,0,1,5.606,8.418A2.549,2.549,0,0,1,25.228,26.606Zm12.24-2.336c0,.6-.73.9-1.46.9s-1.46-.3-1.46-.9V14.74L34,15.077a.851.851,0,0,1-.468.15c-.543,0-.917-.58-.917-1.161a1.118,1.118,0,0,1,.543-.992l2.471-1.5a1.016,1.016,0,0,1,.543-.131c.6,0,1.292.356,1.292.917Z" />
                                <path
                                  d="M169.982,103.6a2.553,2.553,0,1,0-2.553-2.553A2.556,2.556,0,0,0,169.982,103.6Z"
                                  transform="translate(-151.621 -89.208)"
                                />
                              </g>
                            </svg>
                          </div>
                        </span>
                      </li>
                    ) : (
                      <></>
                    )}
                  </ul>
                </div>
                <hr />
                <div className="accordion-content">
                  <div className="accordion">
                    {this.state.data.event.faq ? (
                      <EventAccordion
                        skClick={this.openSk}
                        title="FAQ"
                        type="faq"
                        data={this.state.data.event.faq}
                      />
                    ) : (
                      <></>
                    )}
                    {this.state.data.event.sk ? (
                      <div ref={this.skRef}>
                        <EventAccordion
                          open={this.state.skOpen}
                          title="Syarat &amp; Ketentuan"
                          data={this.state.data.event.sk}
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                    {/*<WinnerSlider id={this.pageData.artist.id} />*/}
                  </div>
                </div>
              </div>
            </div>
            <Footer />
          </>
        )}
      </>
    );
  }
}

export default EventPage;
